var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTarget(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256.1 256.01",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "fill-secondary",
    d: "M178.66,79.37,166.93,91.1a76.68,76.68,0,0,1,4.91,11.52,85.77,85.77,0,0,1,14.93-1.28h1.39A93.65,93.65,0,0,0,178.66,79.37ZM0,128a96.1,96.1,0,0,0,109.65,95A82.93,82.93,0,0,1,104,207.58a67,67,0,0,1-8,.43A80,80,0,0,1,96,48a79,79,0,0,1,37,9.17l11.73-11.73A94.73,94.73,0,0,0,96,32,96.14,96.14,0,0,0,0,128Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "fill-secondary",
    d: "M37.33,128A58.78,58.78,0,0,0,96,186.68a47.26,47.26,0,0,0,5.44-.32A82.71,82.71,0,0,1,103,170a37.32,37.32,0,0,1-7,.64,42.67,42.67,0,0,1,0-85.34,32.88,32.88,0,0,1,8,.84l12.91-12.91a57,57,0,0,0-20.91-4A58.81,58.81,0,0,0,37.33,128Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "fill-secondary",
    d: "M96,106.68A21.33,21.33,0,1,0,117.33,128,21.39,21.39,0,0,0,96,106.68Zm0,26.66a5.33,5.33,0,1,1,5.33-5.33A5.28,5.28,0,0,1,96,133.34Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "fill-primary",
    d: "M96.1,136a8,8,0,0,1-5.67-13.65L159.76,53a8,8,0,0,1,11.31,11.31l-69.33,69.33A8,8,0,0,1,96.1,136Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "fill-primary",
    d: "M194.77,64H168.1a8,8,0,0,1-8-8V29.34a8.08,8.08,0,0,1,2.33-5.67L183.76,2.34A8,8,0,0,1,197.42,8V26.68H216.1a8,8,0,0,1,5.66,13.66L200.43,61.67A8,8,0,0,1,194.77,64Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "fill-primary",
    d: "M186.77,117.34a69.34,69.34,0,1,0,69.33,69.34A69.4,69.4,0,0,0,186.77,117.34Zm29.87,56.11L182,210.78a8,8,0,0,1-11.09.64l-18.67-16a8,8,0,1,1,10.41-12.15l12.84,11,29.44-31.69a8,8,0,0,1,11.74,10.88Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTarget);
export default __webpack_public_path__ + "static/media/target.def4e2df9e05f6dfd4507c7025e391ca.svg";
export { ForwardRef as ReactComponent };